import $ from 'jquery';

$(document).ready(function () {
  acfLayoutOptionBlock();
});

function acfLayoutOptionBlock() {
  $('.js-acf-layout-option').each(function () {});
}
